<template>
  <button
    :class="['ctrl-btn', `btn-${variant}`, { 'btn-loading': loading }]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="btn-spinner"></span>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  name: "CtrlButton",
  props: {
    variant: {
      type: String,
      default: "primary", // primary, secondary, danger
      validator: (value) => ["primary", "secondary", "danger"].includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.ctrl-btn {
  height: 38px;
  padding: 0 16px;
  border-radius: var(--border-radius-md);
  font-family: var(--font-family-header);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: var(--transition-premium);
  border: none;
  white-space: nowrap;
  user-select: none;
}

.ctrl-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Primary Variant */
.btn-primary {
  background-color: var(--primary-color);
  color: var(--text-main);
  box-shadow: 0 4px 12px rgba(255, 214, 0, 0.2);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-hover);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(255, 214, 0, 0.3);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

/* Secondary Variant */
.btn-secondary {
  background-color: var(--surface-color);
  color: var(--gray-700);
  border: 1px solid var(--gray-200);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--gray-100);
  border-color: var(--gray-300);
}

/* Danger Variant */
.btn-danger {
  background-color: var(--surface-color);
  color: var(--error-text);
  border: 1px solid #fee2e2;
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--error-bg);
  border-color: #fecaca;
}

/* Loading State */
.btn-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
